import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-reconnect',
  imports: [FormsModule, DatePickerModule],
  providers: [DatePipe],
  templateUrl: './reconnect.component.html',
  styleUrl: './reconnect.component.scss',
  standalone: true
})

export class ReconnectComponent {
  reconnectSelectedDate: Date | null = null;
  @Input() reconnectDate: Date | null = null;
  @Output() formValuesChange = new EventEmitter<any>();

  reconnectformatedDate: string | null = null;
  constructor(private datePipe: DatePipe) {
  }

  ngOnInit(): void {

    if (this.reconnectDate != null) {
      this.reconnectDate = new Date(this.reconnectDate);
      this.reconnectSelectedDate = this.reconnectDate;
    }
  }

  onDateChange(event: any) {
    this.reconnectSelectedDate = event;
    this.reconnectformatedDate = this.datePipe.transform(this.reconnectSelectedDate, 'MM/dd/yyyy');
    this.emitFormValues();
  }

  emitFormValues() {
    const formValues = {
      reconnectSelectedDate: this.reconnectSelectedDate,
      reconnectformatedDate: this.reconnectformatedDate,
    };
    this.formValuesChange.emit(formValues);
  }
}